import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form/form';
import { useMemo } from 'react';
import { SimpleFinAccountField } from '../ui/field/simple-fin-account-field';
import { Account, getSimpleFinAccountOptions, useAccountForm, useGetSimpleFinAccountsApi } from '@liquidbudget/common';

type Props = {
  account: Account;
  onClose: () => void;
  onSuccess?: () => void;
};

export function SimpleFinAccountForm({ account, onClose, onSuccess }: Props) {
  const { data: simpleFinAccounts } = useGetSimpleFinAccountsApi();
  const { form, onSubmit, isSubmitting } = useAccountForm({
    account,
    onSuccess: () => {
      onSuccess?.();
      onClose();
    },
  });

  const simpleFinGroups = useMemo(() => {
    if (!simpleFinAccounts) return [];
    return getSimpleFinAccountOptions(simpleFinAccounts);
  }, [simpleFinAccounts]);

  return (
    <Form {...form}>
      <form onSubmit={onSubmit}>
        <div className="space-y-4">
          <SimpleFinAccountField
            name="simpleFinAccountId"
            control={form.control}
            groups={simpleFinGroups}
            isSmallScreen={false}
          />
        </div>

        <div className="flex justify-end gap-2 pt-6">
          <Button type="button" variant="outline" disabled={isSubmitting} onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" isLoading={isSubmitting}>
            Save
          </Button>
        </div>
      </form>
    </Form>
  );
}
